import { types, Image } from "react-bricks/frontend";
import styled from "styled-components";
import TextBlock from "../common/TextBlock";

export interface EventsBarItemProps {
  hasIcon: boolean;
  textColor?: types.IColor;
}

export const EventsBarItem: types.Brick<EventsBarItemProps> = ({ hasIcon, textColor }) => {
  return (
    <ItemContainer>
      {hasIcon && <Image propName="iconImage" alt={"icon"} maxWidth={32} />}
      <Description color={textColor.color}>
        <TextBlock
          propName="description"
          placeholder="Live Webinar"
          renderBlock={({ children }) => <>{children}</>}
        />
      </Description>
    </ItemContainer>
  );
};

EventsBarItem.schema = {
  name: "events-bar-block",
  label: "Events Bar Block",
  category: "Events Bar Components",
  hideFromAddMenu: true,
  // Define default props
  getDefaultProps: () => ({
    hasIcon: true,
    description: "Live Webinar",
    iconImage: {
      src: "/static/icons/Event.svg",
    },
  }),
  // Define side edit props
  sideEditProps: [
    {
      name: "hasIcon",
      label: "Show Icon",
      type: types.SideEditPropType.Boolean,
    },
  ],
};

const MOBILE_BREAKPOINT = `@media only screen and (max-width: 65rem)`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  gap: 1rem;
  white-space: nowrap;

  ${MOBILE_BREAKPOINT} {
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    padding-top: 2.5rem;
  }
`;

const Description = styled.div<{
  color: string;
}>`
  color: ${(p) => p.color};
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.075rem;
  white-space: nowrap;
  text-align: center;

  ${MOBILE_BREAKPOINT} {
    margin: 0;
    text-align: center;
  }
`;

export default EventsBarItem;
